var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGutzeichen = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: "0px",
    y: "0px",
    viewBox: "-275 404.8 43.2 33.1",
    enableBackground: "new -275 404.8 43.2 33.1",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#92D154",
    d: "M-231.8,411.3c0,0.7-0.3,1.4-0.8,1.9l-20.1,20.2l-3.8,3.8c-0.5,0.5-1.2,0.8-1.9,0.8c-0.7,0-1.4-0.3-1.9-0.8 l-3.8-3.8l-10.1-10.1c-0.5-0.5-0.8-1.2-0.8-1.9c0-0.7,0.3-1.4,0.8-1.9l3.8-3.8c0.5-0.5,1.2-0.8,1.9-0.8s1.4,0.3,1.9,0.8l8.2,8.2 l18.3-18.3c0.5-0.5,1.1-0.8,1.9-0.8s1.4,0.3,1.9,0.8l3.8,3.8C-232,409.9-231.8,410.5-231.8,411.3z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGutzeichen, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/gutzeichen.13523937.svg";
export { ForwardRef as ReactComponent };